import React, {useState, useEffect} from 'react';
import useApi from '../../Hooks/useApi'

import './SalesOrderDatabase.css';

// custom components
import SalesOrdersDataTable from '../../Components/SalesOrdersDataTable/SalesOrdersDataTable'
//carbon components
import { DataTableSkeleton } from 'carbon-components-react';

function SalesOrderDatabase(props) {
  //get props
  const {token } = props
  //set state
  const [refresh, setRefresh] = useState(false)
  // fetch the inventory data
  const apiPath = '/sales-orders'
  const {error, loading, data, fetchData} = useApi(token, apiPath)


  // additional table-specific vars
  const collator = new Intl.Collator();
  const propSortInfo = {
    columnId: 'description',
    direction: 'NONE',
  };

  if (error) {
    console.error(error)
    return (
      <div>
        <p>An error has occurred, please refresh the page</p>
      </div>
    )
  }

  if (loading) {
    console.log("ok this now,");
    return (
    <div id="homeContainer">
      <h3 id="quoteDBTitle">Sales Orders Database</h3>
      <div id="skeletonDataTableCont">
        <DataTableSkeleton showToolbar={false} id="skeletonTable">
        </DataTableSkeleton>
      </div>
    </div>
    )
  }

  console.log("RENDER?");
  return (
    <div id="homeContainer">
      <h3 id="quoteDBTitle">Sales Order Database</h3>
      <SalesOrdersDataTable token={token} salesOrdersData={data.salesOrders} refreshData={fetchData} />
    </div>

  );
}

export default SalesOrderDatabase;
